// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import translate from "@insite/client-framework/Translate";
import { TraitValueModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
// import Swatch, { SwatchTypeValues } from "@insite/mobius/Swatch"; // Valtech Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";

/* Valtech Custom Code */
import Swatch, { SwatchTypeValues } from "@store/MobiusOverrides/Swatch/Swatch";
import { swatchListItemStyles, swatchListStyles } from "@store/Themes/common/mixins/swatch";
import { swatchProps } from "@store/Themes/common/props/swatch";
/* Valtech Custom Code */

interface Props {
    variantSelection: SafeDictionary<string>;
    variantTrait: VariantTraitModel;
    updateVariantSelection: (traitValueId: string, variantTraitId: string) => void;
}

export interface ProductDetailsVariantListStyles {
    labelText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    labelWrapper?: InjectableCss;
    swatchClickable?: ClickablePresentationProps;
    swatchCaptionProps?: InjectableCss;
    // Valtech Custom Code
    wrapper?: InjectableCss;
}

export const variantListStyles: ProductDetailsVariantListStyles = {
    wrapper: swatchProps.wrapper,
    labelText: swatchProps.label,
    swatchCaptionProps: swatchProps.caption,
    swatchClickable: swatchProps.clickable,
};

const SwatchListDisplayItem = styled.li`
    ${swatchListItemStyles() /* Valtech Custom Code */}
`;

export const UnorderedList = styled.ul<InjectableCss>`
    /* Valtech Custom Code */
    ${swatchListStyles()}
    flex-direction: column;
    /* Valtech Custom Code */
    ${injectCss}
`;

const styles = variantListStyles;

const ProductDetailsVariantSwatchList = ({ variantSelection, updateVariantSelection, variantTrait }: Props) => {
    const updateVariantSelectionSwatchList = (traitValueId?: string) => {
        updateVariantSelection(traitValueId ?? "", variantTrait.id);
    };

    const CreateSwatchListItem = (traitValue: TraitValueModel) => {
        const isSelected = variantSelection[variantTrait.id] === traitValue.id;

        return (
            <SwatchListDisplayItem key={traitValue.id}>
                <Clickable
                    onClick={() => updateVariantSelectionSwatchList(isSelected ? "" : traitValue.id)} // Valtech Custom Code
                    disabled={traitValue.isDisabled}
                    {...styles.swatchClickable}
                    // Valtech Custom Code
                    data-selected={isSelected || undefined}
                    title={
                        traitValue.valueDisplay && !variantTrait.displayTextWithSwatch
                            ? traitValue.valueDisplay
                            : undefined
                    }
                >
                    <Swatch
                        type={traitValue.swatchType as SwatchTypeValues}
                        value={
                            traitValue.swatchType === SwatchTypeValues.Image
                                ? traitValue.swatchImageValue
                                : traitValue.swatchColorValue
                        }
                        size={28} // Valtech Custom Code
                        caption={variantTrait.displayTextWithSwatch ? traitValue.valueDisplay : undefined}
                        isDisabled={traitValue.isDisabled}
                        captionProps={styles.swatchCaptionProps}
                        isSelected={isSelected} // Valtech Custom Code
                    />
                </Clickable>
            </SwatchListDisplayItem>
        );
    };

    return (
        <StyledWrapper {...styles.wrapper /* Valtech Custom Code */} key={variantTrait.id}>
            <StyledWrapper {...styles.labelWrapper}>
                <Typography {...styles.labelText}>{variantTrait.nameDisplay}</Typography>
                {/* Valtech Removed - Clear Selection */}
            </StyledWrapper>
            <UnorderedList>
                {variantTrait.traitValues?.map(traitValue => CreateSwatchListItem(traitValue))}
            </UnorderedList>
        </StyledWrapper>
    );
};

export default ProductDetailsVariantSwatchList;
